import EditorTab from './EditorTab.js';

/**
 * @module SchedulerPro/widget/taskeditor/FormTab
 */

/**
 * Base class for tabs that **contain fields** (form-like tabs) in {@link SchedulerPro.widget.SchedulerTaskEditor scheduler task editor} or
 * {@link SchedulerPro.widget.GanttTaskEditor gantt task editor}, such as General or Notes.
 *
 * @extends SchedulerPro/widget/taskeditor/EditorTab
 */
export default class FormTab extends EditorTab {

    static $name = 'FormTab';

    static type = 'formtab';

    static configurable = {
        layoutStyle : {
            flexFlow     : 'row wrap',
            alignItems   : 'flex-start',
            alignContent : 'flex-start'
        },

        scrollable : {
            overflowY : true
        },

        autoUpdateRecord : true,

        autoUpdateUserChangesOnly : false
    };

    shouldUpdateRecordOnAction(record, event) {
        // do not apply field values to the loaded record while the record gets loaded
        return super.shouldUpdateRecordOnAction(...arguments) && !this.$callingLoadEvent;
    }
}

FormTab.initClass();
